import React from "react";
import { FlowState, QueryItem } from "../@types";
import { getLabelFromQuery } from "./convertQueryToString";
import { nextFlowState } from "./flowControlUtils";
import { FLOW_STATES } from "../consts";
import { generateRandomString } from "../../../../../utils";

export const createNewOption = ({
  label,
  value,
  complexValue,
  flowState,
  useValueAsItemKey = false
}: {
  value: string;
  label?: React.ReactNode;
  flowState: FlowState;
  useValueAsItemKey?: boolean;
  complexValue?: Array<string>;
}): QueryItem => ({
  label: label ?? value.trim(),
  complexValue,
  value: value.trim(),
  itemKey: useValueAsItemKey ? value : generateRandomString(),
  state: flowState
});

export const createNewGroupOption = ({
  value,
  flowState,
  keyword,
  isEditing,
  grouped
}: {
  value: string;
  flowState: FlowState;
  keyword?: string;
  isEditing?: boolean;
  grouped?: Array<QueryItem>;
}): QueryItem => ({
  value: grouped ? getLabelFromQuery(grouped) : value.trim(),
  itemKey: generateRandomString(), // so that the react-select can have values with the same label
  label: grouped ? getLabelFromQuery(grouped) : value.trim(),
  state: FLOW_STATES.GROUP,
  keyword: keyword ?? value.trim(),
  grouped:
    grouped ??
    (value
      ? [
          createNewOption({
            value,
            flowState
          })
        ]
      : undefined),
  isEditing
});

export const createOptionsArrayWithComplexValue = ({
  currentGroup,
  optionToAdd,
  flowState
}: {
  currentGroup?: QueryItem[];
  optionToAdd: QueryItem;
  flowState: FlowState;
}) => {
  if (optionToAdd.complexValue) {
    const newOptions: Array<QueryItem> = [];
    let lastFlowState = flowState;
    const lastElementOfLastGroup = currentGroup?.at(-1);
    if (
      optionToAdd.complexValue.length > 1 &&
      lastElementOfLastGroup?.state === FLOW_STATES.ALL_KEYWORDS
    ) {
      newOptions.push(
        createNewOption({
          value: "[",
          flowState: lastFlowState
        })
      );
      lastFlowState = nextFlowState(lastFlowState, "[");
    }

    optionToAdd.complexValue.forEach(singleValue => {
      newOptions.push(
        createNewOption({
          value: singleValue,
          flowState: lastFlowState
        })
      );
      lastFlowState = nextFlowState(lastFlowState, singleValue);
    });

    return newOptions;
  }

  return [
    createNewOption({
      value: optionToAdd.value,
      flowState
    })
  ];
};
